import loadable from '@loadable/component';

/* AUTH PAGES*/
const Animal = loadable(() => import('./animal'));
const Animals = loadable(() => import('./animals'));
const Land = loadable(() => import('./land'));
const Lands = loadable(() => import('./lands'));
const Profile = loadable(() => import('./profile'));
const Analysis = loadable(() => import('./analysis'));
const Users = loadable(() => import('./users'));

export { Animal, Animals, Lands, Land, Profile, Analysis, Users };
